export const resolvePageDescription = ({
  override,
  prop,
  route,
}: {
  override?: string | null;
  prop?: string;
  route: string;
}): string | null => {
  if (override !== undefined) {
    return override;
  }

  return prop || route;
};
